import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBranding } from 'modules/Common/hooks/useBranding';
import ReleaseNoteList from './ReleaseNoteList';
import { useWhatsNewUnread } from '../hooks/useWhatsNewUnread';

// The body of the "What's new" tab inside Clerk's OrganizationProfile (D9).
//
// The frame only — heading and spacing to match the sibling tabs
// (OrganizationPreferences); the content itself is ReleaseNoteList (D10).
export default function WhatsNewPanel() {
  const { t } = useTranslation('app');
  const brandName = useBranding((s) => s.name);
  const { releases, markAllRead } = useWhatsNewUnread();

  // Read on open, not on scroll. Opening the tab is the strongest signal we
  // get; a per-entry scroll observer would be more precise and less honest,
  // since people skim a changelog rather than read it line by line.
  useEffect(() => {
    if (releases.length) markAllRead();
  }, [releases, markAllRead]);

  // D3: no releases, no panel. The tab is already conditional on the same
  // query — this covers the query emptying while the modal is open.
  if (!releases.length) return null;

  return (
    <div className="flex flex-col gap-2 mt-1">
      {/* D6: the brand is interpolated, never literal — scripts/lint-brand.js
          fails a new file on a single "Carbon Glance" match, and a whitelabel
          build must render its own name here. */}
      <h1>{t('whatsNew.title', "What's new in {{brand}}", { brand: brandName })}</h1>
      <p className="text-sm text-slate-500 mb-3">
        {t('whatsNew.subtitle', 'Recent updates and improvements, newest first.')}
      </p>
      <ReleaseNoteList releases={releases} />
    </div>
  );
}
